











































































































































import Modal from "@/components/shared/modal/Modal.vue";
import i18n from "@/lang/i18n";
import { Pageable } from "@/model/component.model";
import { CountryDTO, ZipRegistryEntryDto } from "@/model/data.model";
import { ShipmentService } from "@/services/ShipmentService";
import Vue from "vue";
import { Component, Prop, Emit } from "vue-property-decorator";
import { required } from "vuelidate/lib/validators";

@Component({
  components: {
    MbeModal: Modal
  },
  validations() {
    return {
      address: {
        subcountry: {
          idSubcountry: {
            required
          }
        }
      }
    };
  }
})
export default class ShipmentCostCalculateAddress extends Vue {
  @Prop() direction: string;
  @Prop() address;
  @Prop() countries: CountryDTO[];

  zipRegistryLocations: ZipRegistryEntryDto[] = [];
  selectZipRegistry: ZipRegistryEntryDto = {} as ZipRegistryEntryDto;
  showZipRegistryLocationModal = false;

  get translatedName(): string {
    return this.countries.find(item => item.id == this.address.country.id)
      ? this.countries.find(item => item.id == this.address.country.id)
          .translatedName
      : "";
  }

  searchZipRegistryLocation() {
    this.selectZipRegistry = {} as ZipRegistryEntryDto;
    ShipmentService.prototype
      .getZipRegistry(
        this.address.country.id,
        this.address.zipCode,
        "",
        this.address.city
      )
      .then((res: any) => {
        const data = res.data as Pageable<ZipRegistryEntryDto>;
        if (data) {
          if (data.content.length === 1) {
            this.selectLocation(data.content[0]);
          } else {
            if (data.content.length > 0) {
              this.zipRegistryLocations = data.content;
              this.showZipRegistryLocationModal = true;
            } else {
              if (this.address.city) {
                this.address.city = "";
                this.searchZipRegistryLocation();
              } else {
                this.$snotify.error(String(i18n.t("no_location_found")));
              }
            }
          }
        }
      })
      .catch((err: any) => {
        this.$snotify.error(err.message);
      });
  }

  selectLocation(location: ZipRegistryEntryDto) {
    this.address.country.id = location.id.country;
    this.address.city = location.id.townName;
    this.address.province = location.id.province;
    const currentZipCode = this.address.zipCode;
    if (currentZipCode !== "") {
      if (
        currentZipCode >= location.id.postcodeFrom &&
        currentZipCode <= location.id.postcodeUntil
      ) {
        this.address.zipCode = currentZipCode;
      }
    } else {
      this.address.zipCode = location.id.postcodeFrom;
    }
    this.selectZipRegistry = location;
    this.showZipRegistryLocationModal = false;
  }

  clearButton() {
    this.changeCity(null);
    this.changeZipCode(null);
    this.changeSubcountry("");
  }

  @Emit("changeCountry")
  changeCountry(data) {
    return { value: data, directionAddress: this.address.directionAddress };
  }

  @Emit("changeSubcountry")
  changeSubcountry(data) {
    return { value: data, directionAddress: this.address.directionAddress };
  }

  @Emit("changeCity")
  changeCity(data) {
    return {
      value: data ? data.target.value : "",
      directionAddress: this.address.directionAddress
    };
  }

  @Emit("changeZipCode")
  changeZipCode(data) {
    return {
      value: data ? data.target.value : "",
      directionAddress: this.address.directionAddress
    };
  }

  get disabledClearButton() {
    return !(
      this.address.subcountry ||
      this.address.zipCode ||
      this.address.city
    );
  }
}
